<!-- Overlay -->
<div
  class="fixed inset-0 z-50 flex items-center justify-center bg-black/40"
>
  <!-- Modal -->
  <div
    class="bg-white rounded-xl shadow-lg w-full max-w-md mx-4 animate-slide-up"
  >
    <!-- Header -->
    <div class="flex justify-between items-center border-b border-gray-200 p-4">
      <h2 class="text-xl font-semibold text-gray-800">{{ title }}</h2>
      <button
        (click)="onClose()"
        class="text-gray-500 hover:text-gray-700 text-2xl leading-none"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Content -->
    <div class="p-4">
      <ng-content></ng-content>
    </div>

    <!-- Footer -->
    <div class="border-t border-gray-200 p-4 flex justify-center space-x-2">
      <button
        (click)="disableLeftButton ? null : onLeft()"
        *ngIf="leftButton"
        [class]="'px-1 py-3 rounded-lg w-full '+ 
        ( disableLeftButton ? 'bg-gray-200 cursor-not-allowed' : leftButtonColor + ' '+ leftTextColor)
        "
      >
        {{ leftText }}
      </button>
      <button
        [class]="'px-1 py-3 rounded-lg w-full '+ 
        ( disableRightButton ? 'bg-gray-200 cursor-not-allowed' : rightButtonColor + ' ' + rightTextColor ) 
        "
        *ngIf="rightButton"
        (click)="disableRightButton ? null : onRight()"
      >
        {{ rightText }}
      </button>
    </div>
  </div>
</div>